unit MaintBudgetSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Vcl.StdCtrls,
  WEBLib.StdCtrls, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, VCL.TMSFNCBitmapContainer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter;

type
  TfrmMaintBudget = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    WebPanel4: TPanel;
    WebButton2: TButton;
    lblDate: TLabel;
    wcBudget: TXDataWebClient;
    wdsBudget: TXDataWebDataSet;
    dsBudget: TDataSource;
    wdsBudgetperiod: TIntegerField;
    wdsBudgetbudget: TFloatField;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    WebButton1: TButton;
    WebButton3: TButton;
    WebButton4: TButton;
    wdsBudgetTotal_Approved: TFloatField;
    wdsBudgetTotal_Not_Approved: TFloatField;
    wdsBudgetBudgetLeft: TFloatField;
    procedure WebButton3Click(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
    wDay , wMonth , wYear : Word;

    function GetYearName : String;
    procedure GetBudgets;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmMaintBudget: TfrmMaintBudget;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes,
  BudgetPeriodSetup;

{ TfrmMaintBudget }

procedure TfrmMaintBudget.GetBudgets;
var
  iPeriod : Integer;

  procedure OnError(Error: TXDataClientError);
    begin
      GetBudgets;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          GetBudgets;
        end
      else
        begin
          console.log(Response.Result);

          wdsBudget.Close;
          wdsBudget.SetJsonData(Response.Result);
          wdsBudget.Open;

          //console.log(GetJsonFromDataset(wdsBudget));
        end;
    end;
begin
  if wMonth < 10 then
    iPeriod := (wYear*100) + wMonth
  else
    iPeriod := StrToInt(IntToStr(wYear) + IntToStr(wMonth));

  ShowMessage(IntToStr(iPeriod));
  wcBudget.RawInvoke('IdashboardService.Get_MaintBudget_View',[wYear+wMonth],@OnSuccess,@OnError);
end;

function TfrmMaintBudget.GetYearName: String;
var
  sMonthYear : String;
begin

  Case wMonth of
    1 : sMonthYear := 'JANUARY ' + IntToStr(wYear);
    2 : sMonthYear := 'FEBRUARY ' + IntToStr(wYear);
    3 : sMonthYear := 'MARCH ' + IntToStr(wYear);
    4 : sMonthYear := 'APRIL ' + IntToStr(wYear);
    5 : sMonthYear := 'MAY ' + IntToStr(wYear);
    6 : sMonthYear := 'JUNE ' + IntToStr(wYear);
    7 : sMonthYear := 'JULY ' + IntToStr(wYear);
    8 : sMonthYear := 'AUGUST ' + IntToStr(wYear);
    9 : sMonthYear := 'SEPTEMBER ' + IntToStr(wYear);
    10 : sMonthYear := 'OCTOBER ' + IntToStr(wYear);
    11 : sMonthYear := 'NOVEMBER ' + IntToStr(wYear);
    12 : sMonthYear := 'DECEMBER ' + IntToStr(wYear);
  End;

  result := sMonthYear;

end;

procedure TfrmMaintBudget.WebButton1Click(Sender: TObject);
var
  newform : TfrmNewBudgetSetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin

        end;
    end;
begin
  newform := TfrmNewBudgetSetup.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmMaintBudget.WebButton3Click(Sender: TObject);
begin
  wMonth := wMonth - 1;
  if wMonth < 1 then
    begin
      wMonth := 12;
      wYear := wYear - 1;
    end;

  lblDate.Caption := GetYearName;
  GetBudgets;
end;

procedure TfrmMaintBudget.WebButton4Click(Sender: TObject);
begin
  wMonth := wMonth + 1;
  if wMonth > 12 then
    begin
      wMonth := 1;
      wYear := wYear + 1;
    end;

  lblDate.Caption := GetYearName;
  GetBudgets;
end;

procedure TfrmMaintBudget.WebFormShow(Sender: TObject);
begin
  DecodeDate(Now,wYear,wMonth,wDay);

  GetBudgets;

  lblDate.Caption := GetYearName;
end;

procedure TfrmMaintBudget.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  lblDate := TLabel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebButton4 := TButton.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebButton2 := TButton.Create(Self);
  wcBudget := TXDataWebClient.Create(Self);
  wdsBudget := TXDataWebDataSet.Create(Self);
  wdsBudgetperiod := TIntegerField.Create(Self);
  wdsBudgetbudget := TFloatField.Create(Self);
  wdsBudgetTotal_Approved := TFloatField.Create(Self);
  wdsBudgetTotal_Not_Approved := TFloatField.Create(Self);
  wdsBudgetBudgetLeft := TFloatField.Create(Self);
  dsBudget := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  lblDate.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebButton4.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  wcBudget.BeforeLoadDFMValues;
  wdsBudget.BeforeLoadDFMValues;
  wdsBudgetperiod.BeforeLoadDFMValues;
  wdsBudgetbudget.BeforeLoadDFMValues;
  wdsBudgetTotal_Approved.BeforeLoadDFMValues;
  wdsBudgetTotal_Not_Approved.BeforeLoadDFMValues;
  wdsBudgetBudgetLeft.BeforeLoadDFMValues;
  dsBudget.BeforeLoadDFMValues;
  try
    Name := 'frmMaintBudget';
    Width := 998;
    Height := 622;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 998;
    WebPanel1.Height := 622;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 998;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Maintenance Budget Setup';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    TMSFNCBitmapContainer1.SetParentComponent(WebPanel2);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 496;
    TMSFNCBitmapContainer1.Top := 16;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 60;
    WebPanel3.Width := 998;
    WebPanel3.Height := 93;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 1;
    WebPanel3.TabOrder := 1;
    lblDate.SetParentComponent(WebPanel3);
    lblDate.Name := 'lblDate';
    lblDate.Left := 72;
    lblDate.Top := 24;
    lblDate.Width := 9;
    lblDate.Height := 15;
    lblDate.Alignment := taCenter;
    lblDate.Caption := '...';
    lblDate.HeightPercent := 100.000000000000000000;
    lblDate.WidthPercent := 100.000000000000000000;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 75;
    WebButton1.Top := 62;
    WebButton1.Width := 105;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Create new period';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton3.SetParentComponent(WebPanel3);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 16;
    WebButton3.Top := 20;
    WebButton3.Width := 50;
    WebButton3.Height := 25;
    WebButton3.Caption := '<<';
    WebButton3.ChildOrder := 2;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    WebButton4.SetParentComponent(WebPanel3);
    WebButton4.Name := 'WebButton4';
    WebButton4.Left := 191;
    WebButton4.Top := 20;
    WebButton4.Width := 50;
    WebButton4.Height := 25;
    WebButton4.Caption := '>>';
    WebButton4.ChildOrder := 3;
    WebButton4.HeightPercent := 100.000000000000000000;
    WebButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton4, Self, 'OnClick', 'WebButton4Click');
    TMSFNCDataGrid1.SetParentComponent(WebPanel1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 153;
    TMSFNCDataGrid1.Width := 998;
    TMSFNCDataGrid1.Height := 409;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 2;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := TMSFNCDataGridDatabaseAdapter1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 5;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.Format := '0000/00';
      Header := 'Period';
      Settings := [gcsFormatting];
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Budget';
      Width := 200.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Complete Orders';
      Width := 200.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OpenOrders';
      Width := 200.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Grand Total Combined';
      Width := 200.000000000000000000;
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('MaintBudgetSetup.WebPanel1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(TMSFNCDataGrid1);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 656;
    TMSFNCDataGridDatabaseAdapter1.Top := 6;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    TMSFNCDataGridDatabaseAdapter1.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'period';
      Header := 'Period';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'budget';
      Header := 'Budget';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Total_Approved';
      Header := 'Complete Orders';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Total_Not_Approved';
      Header := 'OpenOrders';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Grand_Total_Combined';
      Header := 'Grand Total Combined';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter1.DataSource := dsBudget;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 562;
    WebPanel4.Width := 998;
    WebPanel4.Height := 60;
    WebPanel4.Align := alBottom;
    WebPanel4.ChildOrder := 3;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 3;
    WebButton2.SetParentComponent(WebPanel4);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 16;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    wcBudget.SetParentComponent(Self);
    wcBudget.Name := 'wcBudget';
    wcBudget.Connection := dmData.dbConnect;
    wcBudget.Left := 40;
    wcBudget.Top := 8;
    wdsBudget.SetParentComponent(Self);
    wdsBudget.Name := 'wdsBudget';
    wdsBudget.Connection := dmData.dbConnect;
    wdsBudget.Left := 112;
    wdsBudget.Top := 8;
    wdsBudgetperiod.SetParentComponent(wdsBudget);
    wdsBudgetperiod.Name := 'wdsBudgetperiod';
    wdsBudgetperiod.FieldName := 'period';
    wdsBudgetbudget.SetParentComponent(wdsBudget);
    wdsBudgetbudget.Name := 'wdsBudgetbudget';
    wdsBudgetbudget.FieldName := 'budget';
    wdsBudgetTotal_Approved.SetParentComponent(wdsBudget);
    wdsBudgetTotal_Approved.Name := 'wdsBudgetTotal_Approved';
    wdsBudgetTotal_Approved.FieldName := 'Total_Approved';
    wdsBudgetTotal_Not_Approved.SetParentComponent(wdsBudget);
    wdsBudgetTotal_Not_Approved.Name := 'wdsBudgetTotal_Not_Approved';
    wdsBudgetTotal_Not_Approved.FieldName := 'Total_Not_Approved';
    wdsBudgetBudgetLeft.SetParentComponent(wdsBudget);
    wdsBudgetBudgetLeft.Name := 'wdsBudgetBudgetLeft';
    wdsBudgetBudgetLeft.FieldName := 'BudgetLeft';
    dsBudget.SetParentComponent(Self);
    dsBudget.Name := 'dsBudget';
    dsBudget.DataSet := wdsBudget;
    dsBudget.Left := 184;
    dsBudget.Top := 8;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    lblDate.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebButton4.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    wcBudget.AfterLoadDFMValues;
    wdsBudget.AfterLoadDFMValues;
    wdsBudgetperiod.AfterLoadDFMValues;
    wdsBudgetbudget.AfterLoadDFMValues;
    wdsBudgetTotal_Approved.AfterLoadDFMValues;
    wdsBudgetTotal_Not_Approved.AfterLoadDFMValues;
    wdsBudgetBudgetLeft.AfterLoadDFMValues;
    dsBudget.AfterLoadDFMValues;
  end;
end;

end.
